import { Empty } from 'antd';
import { GiftShop_State } from '../../../generated/mlmbox/types/gift_shop';
import { giftShopClient } from './config';
import { getToken } from '../../../utils/helper';

export async function getInfoForMarket(): Promise<GiftShop_State | null> {
    try {
        const { response } = await giftShopClient.info(Empty, { meta: { authorization: getToken() } });

        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
}
